import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { SancionesPersonasService } from "./sanciones-personas.service";
import { DataSharedService } from '../../../../../../../shared/services/data-shared.service';
import { Router } from "@angular/router";
import { DatosPersona, IAccionSancion, IEstadoSancion, IHistorialSancion, SancionesPersona } from "./sanciones-persona.interface";
import { ModalValidarRenovacionComponent } from "src/app/components/core/layouts/modal-validar-renovacion/modal-validar-renovacion.component";
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { DepartamentoEntry } from "src/app/shared/entrys/departamento.entry";
import { MunicipioEntry } from "src/app/shared/entrys/municipio.entry";
import { BasicasLoVService } from "src/app/shared/services/basicas-lov.service";
import { ModalHistorialSancionPersonaComponent } from "src/app/components/core/layouts/modal-historial-sancion-persona/modal-historial-sancion-persona.component";
import { AccionesSancionesEnum, EstadosSancionesEnum } from "./sanciones-persona.enum";
import { ModalModificarSancionPersonaComponent } from '../../../../../layouts/modal-modificar-sancion-persona/modal-modificar-sancion-persona.component';

@Component({
  selector: "app-sanciones-personas",
  templateUrl: "./sanciones-personas.component.html",
  styleUrls: ["./sanciones-personas.component.scss"],
})
export class SancionesPersonasComponent implements OnInit, OnDestroy {
  form: FormGroup;
  paginaActual: number = 1;
  createForm: FormGroup;
  filtro: FormGroup;
  sancionesPersona: SancionesPersona[] = [];
  numero_identificacion: string;
  datosPersona: DatosPersona;
  isSubmitted: boolean= false;
  departamentos: Array<DepartamentoEntry>;
  municipios: Array<MunicipioEntry>;
  estados_sanciones: Array<IEstadoSancion>;
  id_activo= EstadosSancionesEnum.Activo;
  id_inactivo= EstadosSancionesEnum.Innactivo;
  id_eliminado= EstadosSancionesEnum.Eliminado;
  constructor(
    private sancionPersonasService: SancionesPersonasService,
    private basicasLoVService: BasicasLoVService,
    private formBuilder: FormBuilder,
    public authService: AuthService,
    private modalService: NgbModal,
    private dataSharedService: DataSharedService,
    private router: Router,
    private establecimientoComercioService: EstablecimientoComercioService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.onDepartamento();
    this.getEstadosSanciones();
  }
  initForm(): void{
    this.form = this.formBuilder.group({
      numero_identificacion: ["", [Validators.required, ConfirmeValidators.numberValidator,Validators.minLength(5)]]
    });
    this.createForm = this.formBuilder.group({
      nombre                    : ['',Validators.required],
      numero_identificacion     : [''],
      codigo_departamento       : ['',Validators.required],
      codigo_municipio          : ['',Validators.required],
      direccion                 : ['',Validators.required],
      numero_telefonico         : [''],
      correo                    : ['', [Validators.required, Validators.email]],
      correo_fiscal             : ['', [Validators.required, Validators.email]],
    });
    this.filtro = this.formBuilder.group({
      numero_resolucion     : [null],
      fecha_exp_acto_admin  : [null],
      numero_rnt            : [null],
      sancion_estado_id     : [null]
    });
  }

  ngOnDestroy(): void {
    this.sancionesPersona = [];
    this.numero_identificacion = "";
    this.datosPersona = null;
  }
  filtrar(): void{
    this.getSancionesPersonaUsuario(this.datosPersona.persona_id);
  }
  clearFiltro(): void{
    this.filtro.reset();
  }
  getInfo() {
    this.sancionPersonasService
      .getDatosPrestador(this.form.value)
      .subscribe((resultado: ResponseServiceModel) => {
        if (resultado.result) {
          this.isSubmitted = true;
          this.datosPersona = resultado.data;  
          this.numero_identificacion = (this.datosPersona.ingreso_manual)?this.datosPersona.numero_identificacion : this.form.value.numero_identificacion;
          if(this.datosPersona.persona_id){
            this.getSancionesPersonaUsuario(this.datosPersona.persona_id);
          }
          this.validateModelIsEmpty();
        }
      });
  }
  getEstadosSanciones(): void{
    this.sancionPersonasService
        .getEstadosSanciones()
        .subscribe( response =>{
          if(response.result){
            this.estados_sanciones = response.data as Array<IEstadoSancion>;
          }
        })
  }

  getSancionesPersonaUsuario(id: number) {
    this.sancionesPersona = [];
    this.sancionPersonasService
      .getSancionesPersonaActuales(id.toString(),this.filtro.value)
      .subscribe((resultado) => {
        resultado?.data?.forEach((item: any) => {
          const converted: SancionesPersona = { ...item, isCollapsed: true };
          this.sancionesPersona.push(converted);
        });
      });
  }
  onDepartamento() {
    this.basicasLoVService.getDepartamentos(null).subscribe((resultadoD) => {
      if (resultadoD.result) {
        this.departamentos = resultadoD.data as Array<DepartamentoEntry>;
      }
    });
  }
  resetCreateForm(){
    const value = this.createForm.get('numero_identificacion').value;
    this.createForm.reset();
    this.createForm.get('numero_identificacion').setValue(value);
  }
  createPersona(): void{
    this.sancionPersonasService 
        .crearPersona(this.createForm.getRawValue())
        .subscribe(response =>{
          if (response.result) {
            this.isSubmitted = false;
            this.createForm.reset();
            const modalAceptarRenovacion = this.modalService.open(
              ModalValidarRenovacionComponent,
              { centered: true, backdrop: "static", size: "md" }
            );
            modalAceptarRenovacion.componentInstance.mensaje = response.control.message;
          }
        })
  }
  onMunicipio() {
    this.basicasLoVService
      .getMunicipiosxDepartamento(this.createForm.value.codigo_departamento)
      .subscribe((resultado) => {
        if (resultado.result) {
          this.municipios = resultado.data as Array<MunicipioEntry>;
        }
      });
  }
  validateModelIsEmpty(): void{
    if(this.datosPersona == null || this.datosPersona.persona_id == null){
      this.getParam({
        parametro_id:'ADVERTENCIA_NO_RESULTADO_SANCIONES_PERSONAS',
        agrupacion:'VALIDACIONES',
        auxiliar:'1'
      });
      const createControl = this.createForm.get('numero_identificacion');
      createControl.setValue((this.datosPersona.ingreso_manual)?this.datosPersona.numero_identificacion : this.form.value.numero_identificacion);
      createControl.disable();
      if(this.datosPersona.nombre != null && this.datosPersona.ingreso_manual){
        const createControl2 = this.createForm.get('nombre');
        createControl2.setValue(this.datosPersona.nombre);
        createControl2.disable();
      }
    }
  }
  redirectTo() {
    this.dataSharedService.sharedData(
      {
        datosPersona  : this.datosPersona,
        tipo          : AccionesSancionesEnum.asignar
      }
    );
    this.router.navigate(["/admin/sanciones-personas-asignacion"]);

    /*const modalRef = this.modalService.open(ModalAsignarSancionComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
    });
    modalRef.componentInstance.asignar = true;
    modalRef.result.then((resultado) => {
      const modalRef1 = this.modalService.open(
        ModalConfirmarRespuestaComponent,
        {
          centered: true,
          backdropClass: "light-blue-backdrop",
          backdrop: "static",
        }
      );
      const confirmarRespuesta = {} as ConfirmarRespuestaModel;
      confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
      confirmarRespuesta.message = `¿Está seguro que desea asignar la sanción a esta persona?`;
      modalRef1.componentInstance.confirmarRespuesta = confirmarRespuesta;
      modalRef1.result.then(() => {
        this.sancionPersonasService
          .crearSancionPersona({
            titulo: resultado.data.titulo,
            fecha_inicio: resultado.data.fecha_inicio_sancion,
            fecha_fin: resultado.data.fecha_fin_sancion,
            motivo: resultado.data.motivo,
            nombre_a_mostrar: this.datosPersona.nombre_representante_legal
              ? this.datosPersona.nombre_representante_legal
              : this.datosPersona.razon_social,
            correo_electronico_fiscal:
              this.datosPersona.correo_electronico_fiscal,
            solicitud_id: this.datosPersona.solicitud_id,getParam
            codigo_camara: this.datosPersona.codigo_camara,
            archivo: resultado.archivo,
            numero_identificacion: this.id,
          })
          .subscribe((result) => {
            if (result) {
              this.getSancionesPersonaUsuario(this.id);
            }
          });
      });
    });*/
  }
  getParam({parametro_id,agrupacion,auxiliar}): void{
    this.establecimientoComercioService
        .getParametro({
          parametro_id,
          agrupacion,
          auxiliar,
        })
          .subscribe(
            (resultado2) => {
              if (resultado2.result) {
                const modalAceptarRenovacion = this.modalService.open(
                  ModalValidarRenovacionComponent,
                  { centered: true, backdrop: "static", size: "md" }
                );
                modalAceptarRenovacion.componentInstance.mensaje =
                  resultado2.data;
              }
            },
            (error) => {
            }
          );
  }
  
  onViewHistorial(item: SancionesPersona): void{
    const modalRef = this.modalService.open(ModalHistorialSancionPersonaComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      size: 'xl'
    });
    modalRef.componentInstance.sancion_id = item.sancion_id;
    modalRef.result.then(() => {});
  }
  onAcciones(item:SancionesPersona,accion: IAccionSancion){
    switch(accion.id){
      case AccionesSancionesEnum.editar:
        this.dataSharedService.sharedData(
          {
            datosPersona  : { 
                              ...item, 
                              numero_identificacion: this.datosPersona.numero_identificacion,
                              nombre: this.datosPersona.nombre
                            },
            tipo          : AccionesSancionesEnum.editar
          }
        );
        this.router.navigate(["/admin/sanciones-personas-asignacion"]);
        break;
      case AccionesSancionesEnum.eliminar:
        this.eliminarOInactivarSancion(item.sancion_id,AccionesSancionesEnum.eliminar);
        break;
      case AccionesSancionesEnum.innactivar:
        this.eliminarOInactivarSancion(item.sancion_id,AccionesSancionesEnum.innactivar);
          break;
    }
  }
  eliminarOInactivarSancion(sancion_id : number, type: AccionesSancionesEnum): void{
    const modalRef =this.modalService.open(ModalModificarSancionPersonaComponent,{
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      size: 'xl'
    });
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.sancion_id = sancion_id;
    modalRef.result.finally(() => {
      this.wait(2000);
      this.filtrar() ;
    });
  }
  wait(ms){
    var start = new Date().getTime();
    var end = start;
    while(end < start + ms) {
      end = new Date().getTime();
   }
 }
  get headerTabla(): string[]{
    return [
      'Número de resolución',
      'Fecha de creación',
      'Fecha de expedición',
      'Fecha de ejecutoria',
      'Aplica sanción de 5 años',
      'Números RNT',
      'Estado de la sancion',
      'Historial de la sanción',
      'Acciones'
    ]
  }
  get accionesActivo():IAccionSancion[]{
    return[
      {
        id: AccionesSancionesEnum.editar,
        descripcion:'Editar/Detalle'
      },{
        id: AccionesSancionesEnum.innactivar,
        descripcion:'Inactivar'
      },{
        id: AccionesSancionesEnum.eliminar,
        descripcion:'Eliminar'
      },
    ];
  }
  get accionesEliminado():IAccionSancion[]{
    return[
      {
        id: AccionesSancionesEnum.editar,
        descripcion:'Editar/Detalle'
      }
    ];
  }
  get accionesInactivo():IAccionSancion[]{
    return[
      {
        id: AccionesSancionesEnum.editar,
        descripcion:'Editar/Detalle'
      },{
        id: AccionesSancionesEnum.eliminar,
        descripcion:'Eliminar'
      },
    ];
  }
}
